jQuery(document).ready(function ($) {
    var originalBrutto = $('.brutto-price').html();
    var originalNetto = $('.netto-price').html();

    $('form.variations_form').on('show_variation', function (event, variation) {
        if (typeof variation.custom_brutto === 'undefined') return;

        var priceBrutto = parseFloat(variation.custom_brutto);
        var priceNetto = parseFloat(variation.custom_netto);

        var formattedBrutto = priceBrutto.toFixed(2).replace('.', ',') + ' zł brutto';
        var formattedNetto = priceNetto.toFixed(2).replace('.', ',') + ' zł netto bez vat';

        $('.brutto-price').html(formattedBrutto);
        $('.netto-price').html(formattedNetto);
        $('.platek-price').addClass('price-activated');
    });

    $('form.variations_form').on('reset_data', function () {
        $('.brutto-price').html(originalBrutto);
        $('.netto-price').html(originalNetto);
        $('.platek-price').removeClass('price-activated');
    });

    $('.custom-product-content .platek-tabs-navigation a').on('click', function(e){
        e.preventDefault();
        e.stopImmediatePropagation();
        $('.custom-product-content .platek-tabs-navigation a').removeClass('active');
        $(this).addClass('active');
        $('.platek-tabs-content > div').removeClass('active');
        $('.platek-tabs-content ' + $(this).attr('href')).addClass('active');
        $('html, body').animate({
            scrollTop: parseInt($($(this)).offset().top - 100)
        }, 1000);
    })
});
